import { useEffect, useRef } from 'react';
import useDataLayer from '~/services/datalayer';

export default function LinkedinFollowButton() {
  let interval: ReturnType<typeof setInterval> | undefined;
  const containerRef = useRef<HTMLDivElement>(null);
  const dataLayer = useDataLayer();

  const bindLinkedinClick = () => {
    interval = setInterval(() => {
      try {
        if (
          document.activeElement?.parentElement?.parentElement ===
          containerRef.current
        ) {
          clearInterval(interval);
          dataLayer.push({
            event: 'linkedin follow click',
          });
        }
      } catch (e) {
        window.console.warn(e);
      }
    }, 100);
  };

  const addLinkedinWidget = () => {
    if (!containerRef.current) {
      return;
    }

    containerRef.current.innerHTML =
      '<script type="IN/FollowCompany" data-id="3240523" data-counter="left" data-width="400"/>';

    const id = 'https://platform.linkedin.com/in.js';
    const existing = document.getElementById(id);
    existing?.parentNode?.removeChild(existing);

    const script = document.createElement('script');
    script.id = script.src = id;
    script.innerHTML = ' lang: en_US';
    document.head.appendChild(script);
  };

  useEffect(() => {
    addLinkedinWidget();
    bindLinkedinClick();
    return () => {
      clearInterval(interval);
    };
  });

  return <div ref={containerRef} />;
}
